import TabPanel from '../../../components/ui/tabs/TabPanel';
import { OrderStatus } from '../../../lib/api/orders/enums/order-status.enum';
import useOrdersFulfillmentTable from '../hooks/useOrdersFulfillmentTable';
import OrdersPickingTable from '../tables/OrdersPickingTable';

interface Props {
  label: string;
  tabValue: number;
  index: number;
}

export default function OrdersPickingTab({ tabValue, index }: Props) {
  const { tableState, setTableState, isFetching, orders, handleChangeStatus } =
    useOrdersFulfillmentTable({
      filters: {
        status: { eq: OrderStatus.selectedforpicking },
      },
    });
  return (
    <TabPanel value={tabValue} index={index}>
      <OrdersPickingTable
        apiRes={orders}
        isFetching={isFetching}
        setTableState={setTableState}
        tableState={tableState}
        onChangeStatus={handleChangeStatus}
      />
    </TabPanel>
  );
}
